import { Component, OnInit, OnDestroy } from '@angular/core';
import { MultiLineComponentTemplate, FormService, ComponentManagerService, MultiLineFormModalComponent, ModalFormValueChange, MultiLineModalResponse, BooleanType, AmountComponent } from '@fgpp-ui/components';
import { FeeFormulaTiers } from '../../../../models/fee-formula-tiers.model';


@Component({
  selector: 'app-fee-formula-tier-modal',
  template: MultiLineComponentTemplate.HTML_TEMPLATE,
  styles: [MultiLineComponentTemplate.STYLE_TEMPLATE],
  providers: [
    FormService,
    ComponentManagerService
  ]
})
export class FeeFormulaTierModalComponent extends MultiLineFormModalComponent implements OnInit, OnDestroy {

  private readonly GapBetweenTierLines = 0.01;
  private readonly DefaultLastToAmount = 99999999999999;

  private get isNewLine(): boolean {
    return this.data.dataIndex === -1;
  }

  private get isLastLine(): boolean {
    return this.data.dataIndex === this.data.controllerValue?.length - 1;
  }

  protected formLoadComplete(): void {
    super.formLoadComplete();
    this.setFromAmount();
    this.markToAmountAsRequired();
    this.disableAmountControl(this.formMgr.get(FeeFormulaTiers.FIXED_FEE).getValue(), FeeFormulaTiers.PERCENTAGE);
    this.disableAmountControl(this.formMgr.get(FeeFormulaTiers.PERCENTAGE).getValue(), FeeFormulaTiers.FIXED_FEE);
    this.addBeforeSaveEventListener();
  }

  protected valueChanges(change: ModalFormValueChange): void {
    switch (change.control) {
      case FeeFormulaTiers.FROM_AMOUNT:
        this.updateToAmountValidation();
        break;
      case FeeFormulaTiers.FIXED_FEE:
        this.disableAmountControl(change.value, FeeFormulaTiers.PERCENTAGE);
        break;
      case FeeFormulaTiers.PERCENTAGE:
        this.disableAmountControl(change.value, FeeFormulaTiers.FIXED_FEE);
        break;
    }
  }

  private setFromAmount(): void {
    if (this.isNewLine) {
      const fromAmountControl = this.formMgr.get(FeeFormulaTiers.FROM_AMOUNT);
      const tiers = this.data.controllerValue;
      if (!tiers?.length) {
        fromAmountControl.setValue(0);
      } else {
        const prevToAmount = tiers[tiers.length - 1][FeeFormulaTiers.TO_AMOUNT];
        if (prevToAmount !== null) {
          fromAmountControl.setValue(+prevToAmount + this.GapBetweenTierLines);
        }
      }
    }
  }

  private setToAmount(): void {
    if (this.isNewLine || this.isLastLine) {
      const toAmountControl = this.formMgr.get(FeeFormulaTiers.TO_AMOUNT);
      if (!toAmountControl.getValue()) {
        toAmountControl.setValue(this.DefaultLastToAmount);
      }
    }
  }

  private markToAmountAsRequired(): void {
    if (!this.isNewLine && !this.isLastLine) {
      this.formMgr.get(FeeFormulaTiers.TO_AMOUNT).markAsRequired();
    }
  }

  private addBeforeSaveEventListener(): void {
    this.addEventListener('beforeSave', (rowIndex: number[], data: any) => {
      const isValid = this.validateTier();
      if (isValid) {
        this.setToAmount();
        return true;
      }
      return false;
    });
  }

  private disableAmountControl(currentChangedControlValue: number, controlToDisable: FeeFormulaTiers): void {
    const control = this.formMgr.get(controlToDisable);
    if (currentChangedControlValue) {
      if (!control.getLayoutControl().controller.disabled) {
        control.disable();
      }
    } else if (control.getLayoutControl().controller.disabled) {
      control.enable();
    }
  }
  private updateToAmountValidation(): void {
    const fromAmountControl = this.formMgr.get(FeeFormulaTiers.FROM_AMOUNT);
    const toAmountControl = this.formMgr.get(FeeFormulaTiers.TO_AMOUNT);
    const fromAmount = fromAmountControl.getValue();
    const toAmountMinimumValidation = fromAmount || fromAmount === 0 ? fromAmount + 0.01 : 0;
    toAmountControl.getLayoutControl<AmountComponent>().set('minimum', toAmountMinimumValidation);
  }

  private validateTier(): boolean {
    return this.validateMandatoryFixedAmountOrPercentage();
  }

  private validateMandatoryFixedAmountOrPercentage(): boolean {
    const fixedAmount = this.formMgr.get(FeeFormulaTiers.FIXED_FEE);
    const percentage = this.formMgr.get(FeeFormulaTiers.PERCENTAGE);
    if (!fixedAmount.getValue() && fixedAmount.getValue() !== 0 && !percentage.getValue() && percentage.getValue() !== 0) {
      this.notificationService.error(this.translate.instant('business-framework.profiles.415.errors.mandatory-fixed-amount-or-percentage'));
      return false;
    }
    return true;
  }
}
